import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class AdminGetPublisherApplicationArgs {
  @Field(t => Int)
  userId!: number
}
